import React from 'react';
import { useToast } from '../../contexts/ToastContext';

const variantClasses = {
  default: 'bg-card text-foreground border-border',
  success: 'bg-green-600 text-white border-green-500',
  warning: 'bg-yellow-600 text-white border-yellow-500',
  destructive: 'bg-destructive text-destructive-foreground border-destructive/80',
};

const Toaster = () => {
  const { toasts, remove } = useToast();
  return (
    <div className="fixed bottom-4 right-4 z-[100] space-y-3">
      {toasts.map((t) => (
        <div key={t.id} className={`w-80 shadow-lg rounded-md border p-3 ${variantClasses[t.variant] || variantClasses.default}`}>
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              {t.title && <p className="font-medium truncate">{t.title}</p>}
              {t.description && <p className="text-sm opacity-90 break-words mt-0.5">{t.description}</p>}
            </div>
            <button onClick={() => remove(t.id)} className="text-sm opacity-80 hover:opacity-100">×</button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Toaster;
